// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pmoEntity from './entities/pmo.json';
import pmoMenu from '../pages/pmo/menu.json';
import pmoFullForm from '../pages/pmo/forms/full.json';
import pmoContextForm from '../pages/pmo/forms/context.json';
import pmoMiniForm from '../pages/pmo/forms/mini.json';
import pmoLookupForm from '../pages/pmo/forms/lookup.json';
import pmoTableView from '../pages/pmo/views/table.json';
import pmoStagesView from '../pages/pmo/views/stages.json';
import pmoCardsView from '../pages/pmo/views/cards.json';
import pmoInlineView from '../pages/pmo/views/inline.json';
import pmoBacklogView from '../pages/pmo/views/backlog.json';
import pmoSplitView from '../pages/pmo/views/split.json';
import pmoCalendarView from '../pages/pmo/views/calendar.json';
import pmoDashboardView from '../pages/pmo/views/dashboard.json';

/** Тип запису «Стандарт проєктного офісу» зі сторінками пакета: меню, форми та подання з pages/pmo/. */
export const pmoDefinition: IRecordTypeDefinition = {
  ...pmoEntity,
  views: assembleViewSet({
      table: pmoTableView,
      stages: pmoStagesView,
      cards: pmoCardsView,
      inline: pmoInlineView,
      backlog: pmoBacklogView,
      split: pmoSplitView,
      calendar: pmoCalendarView,
      dashboard: pmoDashboardView,
  }),
  form: pmoFullForm,
  forms: { full: pmoFullForm, context: pmoContextForm, mini: pmoMiniForm, lookup: pmoLookupForm },
  menu: pmoMenu,
} as IRecordTypeDefinition;
